import { ModelBase } from 'store/model-base';

export class CmsInternational extends ModelBase {
    public static storeName: string = 'cmsInternational';

    public header: string;
    public description: string;
    public internationalIcon: CmsMediaImage;
    public searchPlaceholder: string;
    public searchLabel: string;
    public travelRatesHeader: string;
    public callRatesHeader: string;
    public gtpSupportArticle: string;
    public footerDescription: string;
    public footerSubtext: string;
    public footerLink: string;
    public notFoundIcon: CmsMediaImage;
    public notFoundDisclaimer: string;
}
